import { css } from '@emotion/react';
import { Tooltip } from 'antd';
import { useCallback, useState, type MouseEvent } from 'react';

import { colorConstants } from 'config/colorConstants';

export const PACK_ARCHITECTURE_TABLE_TOOLTIP_OVERLAY_CLASS = 'pack-architecture-table-tooltip';

export const packArchitectureTableTooltipGlobalStyles = css`
    .${PACK_ARCHITECTURE_TABLE_TOOLTIP_OVERLAY_CLASS} {
        opacity: 1 !important;
    }

    .${PACK_ARCHITECTURE_TABLE_TOOLTIP_OVERLAY_CLASS} .ant-tooltip-inner {
        opacity: 1 !important;
        background-color: ${colorConstants.blackTitle} !important;
        color: ${colorConstants.white} !important;
    }

    .${PACK_ARCHITECTURE_TABLE_TOOLTIP_OVERLAY_CLASS} .ant-tooltip-arrow {
        opacity: 1 !important;
    }

    .${PACK_ARCHITECTURE_TABLE_TOOLTIP_OVERLAY_CLASS} .ant-tooltip-arrow-content,
    .${PACK_ARCHITECTURE_TABLE_TOOLTIP_OVERLAY_CLASS} .ant-tooltip-arrow::before {
        opacity: 1 !important;
        background-color: ${colorConstants.blackTitle} !important;
        background: ${colorConstants.blackTitle} !important;
    }
`;

const SOLID_TOOLTIP_INNER_STYLE = {
    backgroundColor: colorConstants.blackTitle,
    color: colorConstants.white,
} as const;

type PackArchitectureTableEllipsisTextProps = {
    children: string;
    className?: string;
};

/** Truncates text and shows a solid tooltip only when the label overflows. */
export const PackArchitectureTableEllipsisText = ({
    children,
    className,
}: PackArchitectureTableEllipsisTextProps) => {
    const [isTruncated, setIsTruncated] = useState(false);

    const handleMouseEnter = useCallback((event: MouseEvent<HTMLSpanElement>) => {
        const element = event.currentTarget;
        setIsTruncated(element.scrollWidth > element.clientWidth);
    }, []);

    return (
        <Tooltip
            title={isTruncated ? children : undefined}
            overlayClassName={PACK_ARCHITECTURE_TABLE_TOOLTIP_OVERLAY_CLASS}
            overlayInnerStyle={SOLID_TOOLTIP_INNER_STYLE}
        >
            <span className={`block truncate ${className ?? ''}`} onMouseEnter={handleMouseEnter}>
                {children}
            </span>
        </Tooltip>
    );
};
